import $ from 'jquery'

$('a[href^="mailto:"]').addClass('mail-hover')

$('a[href^="mailto:"]').hover(function() {
  $(this).addClass('mail-hover--active');
}, function() {
  $(this).removeClass('mail-hover--active');
});
